module.exports = __webpack_public_path__ + "static/burcu_aybak-c6c5aad7769391eb5d9d04ed945584f6.jpg";